export default {
  DRAWER_NAVIGATOR: 'DrawerNavigator',
  AUTH_NAVIGATOR: 'MainNavigator',
  APP_NAVIGATOR: 'AppNavigator',
  REGISTER_SCREEN: 'RegisterScreen',
  FORGOT_PASSWORD_SCREEN: 'ForgotPasswordScreen',
  SPLASH_SCREEN: 'SplashScreen',
  LOGIN_SCREEN: 'LoginScreen',
  HOME_SCREEN: 'HomeScreen',
  DEBT_BOOK_SCREEN: 'DebtBookScreen',
  DETAIL_CUSTOMER_SCREEN: 'DetailCustomerScreen',
  DETAIL_PROVIDER_SCREEN: 'DetailProviderScreen',
  LIST_RETURN_ORDER_SCREEN: 'ListReturnOrderScreen',
  LIST_IMPORT_RETURN_ORDER_SCREEN: 'ListImportReturnOrderScreen',
  CREATE_IMPORT_RETURN_ORDER_SCREEN: 'CreateImportReturnOrderScreen',
  CREATE_RETURN_ORDER_SCREEN: 'CreateReturnOrderScreen',
  FINANCIAL_BOOK_SCREEN: 'FinancialBookScreen',
  DETAIL_FINANCIAL_SCREEN: 'DetailFinancialScreen',
  DETAIL_ORDER_SCREEN: 'DetailOrderScreen',
  DETAIL_PRODUCT_SCREEN: 'DetailProductScreen',
  DETAIL_CATEGORY_SCREEN: 'DetailCategoryScreen',
  SHOP_SETTING_SCREEN: 'ShopSettingScreen',
  CREATE_PRODUCT_SCREEN: 'CreateProductScreen',
  CREATE_CUSTOMER_SCREEN: 'CreateCustomerScreen',
  CREATE_ORDER_SCREEN: 'CreateOrderScreen',
  DETAIL_INVOICE_DELIVERY_SCREEN: 'DetailInventoryDeliveryScreen',
  DETAIL_INVOICE_SCREEN: 'DetailInvoiceScreen',
  PRINTER_SETTING_SCREEN: 'PrinterSettingScreen',
  LIST_CUSTOMER_GROUP_SCREEN: 'ListCustomerGroupScreen',
  CREATE_CUSTOMER_GROUP_SCREEN: 'CreateCustomerGroupScreen',
  DETAIL_CUSTOMER_GROUP_SCREEN: 'DetailCustomerGroupScreen',
  DETAIL_CUSTOMER_GROUP_PRICE_SCREEN: 'DetailCustomerGroupPriceScreen',
  LIST_SETTING_SCREEN: 'ListSettingScreen',
  GENERAL_SETTING_SCREEN: 'GeneralSettingScreen',
  ORDER_SETTING_SCREEN: 'OrderSettingScreen',
  SHIFT_SETTING_SCREEN: 'ShiftSettingScreen',
  PRODUCT_SETTING_SCREEN: 'ProductSettingScreen',
  HOME_SETTING_SCREEN: 'HomeSettingScreen',
  INVOICE_SETTING_SCREEN: 'InvoiceSettingScreen',
  POINT_SETTING_SCREEN: 'PointSettingScreen',
  STATIC_SHIFT_SCREEN: 'StatisticalShiftScreen',
  WAREHOUSE_CHECK_SCREEN: 'WarehouseCheckScreen',
  LIST_WAREHOUSE_CHECK_SCREEN: 'ListWarehouseCheckScreen',
  LIST_WAREHOUSE_SCREEN: 'ListWarehouseScreen',
  WAREHOUSE_SCREEN: 'WarehouseScreen',
  WAREHOUSE_TRANFER_SCREEN: 'WarehouseTransferScreen',
  LIST_WAREHOUSE_TRANFER_SCREEN: 'ListWarehouseTransferScreen',
  PRINT_BARCODE_SCREEN: 'PrintBarcodeScreen',
  LIST_PRODUCT_BARCODE_SCREEN: 'ListProductBarcodeScreen',
  LIST_DRAFT_ORDER_SCREEN: 'ListDraftOrderScreen',
  DELETE_ACCOUNT_SCREEN: 'DeleteAccountScreen',
  PURCHASE_SCREEN: 'PurchaseScreen',
  LIST_ORDER_BY_DAY_SCREEN: 'ListOrderByDayScreen',
  LIST_ORDER_DATA_SCREEN: 'ListOrderDataScreen',
  LIST_STAFF_SCREEN: 'ListStaffScreen',
  DETAIL_SALES_DEVICE_SCREEN: 'DetailPOSDeviceScreen',
  CART_SALES_DEVICE_SCREEN: 'POSDevicePurchaseScreen',
  POS_BILL_PRINT_SCREEN: 'POSBillPrintScreen',
  LIST_POS_DEVICE_ORDER_SCREEN: 'ListPOSDeviceOrderScreen',
  DETAIL_INVOICE_CHECK_SCREEN: 'DetailInvoiceCheckScreen',
  DETAIL_INVOICE_TRANSFER_SCREEN: 'DetailInvoiceTransferScreen',
  CHANGE_PASSWORD_SCREEN: 'ChangePasswordScreen',
  NOTIFICATION_SCREEN: 'NotificationScreen',
  DETAIL_CUSTOMER_DEBT_SCREEN: 'DetailCustomerDebtScreen',
  DETAIL_SHIFT_SCREEN: 'DetailShiftScreen',
  BILL_SCREEN: 'BillScreen',
  LIST_PROMOTION_SCREEN: 'ListPromotionScreen',
  DETAIL_PROMOTION_SCREEN: 'DetailPromotionScreen',
  CREATE_PROMOTION_SCREEN: 'CreatePromotionScreen',
  EDIT_PROFILE_SCREEN: 'EditProfileScreen',
  SERVICE_SALE_SCREEN: 'ServiceSaleScreen',
  CREATE_ORDER_SERVICE_SCREEN: 'CreateOrderServiceScreen',
  SALE_COUNTER_SCREEN: 'SaleCounterScreen',
  LIST_COMPOSITION_SCREEN: 'ListCompositionScreen',
  CREATE_COMPOSITION_SCREEN: 'CreateCompositionScreen',
  DETAIL_EVENT_SCREEN: 'DetailEventScreen',
  APP_PERMISSION_SETTING_SCREEN: 'AppPermissionSettingScreen',
  LIST_EINVOICE_SCREEN: 'ListEInvoiceScreen',
  EINVOICE_SETTING_SCREEN: 'EInvoiceSettingScreen',
  STAT_POINT_SCREEN: 'StatPointScreen',
  STATS_SCREEN: 'StatsScreen'
};
